import { ColumnsType } from 'antd/es/table';
import {
  createdByColumn,
  DateColumn,
  deleteColumn,
  nameColumn,
  headerTitle,
  emptyHeaderTitle,
} from './columnRenders';
import { ColumnHandlers, LostHour } from './types';
import { columnCell } from '@/utils/renderColumnCell.tsx';

const getColumns = (handlers: ColumnHandlers): ColumnsType<LostHour> => [
  {
    width: 134,
    title: headerTitle('Date'),
    dataIndex: 'date',
    key: 'date',
    render: columnCell((date) => DateColumn(date, handlers.isBreakpoint)),
  },
  {
    width: 271,
    title: headerTitle('Employee'),
    dataIndex: 'employee',
    key: 'name',
    render: columnCell((data) =>
      nameColumn(data?.name, handlers?.isBreakpoint)
    ),
  },
  {
    width: 271,
    title: headerTitle(handlers.isMobile ? 'Hours' : 'Hours'),
    dataIndex: 'hours',
    key: 'hours',
    render: columnCell(),
  },
  {
    width: 271,
    title: headerTitle('Manager'),
    dataIndex: 'created_by',
    key: 'name',
    render: columnCell((data) =>
      nameColumn(data?.name, handlers?.isBreakpoint)
    ),
  },
  {
    width: 135,
    title: headerTitle(handlers.isMobile ? '' : 'Status'),
    dataIndex: 'id',
    key: 'delete',
    render: columnCell(deleteColumn(handlers)),
  },
];

export default getColumns;
